<template>
  <div class="brguides">
    <div class="guides-hero">
      <h1 class="guides-title">What should we explore today?</h1>
      <p class="guides-subtitle">
        Run headless Chrome on
        <a href="https://www.cloudflare.com/zh-cn/network/" target="_blank" rel="noopener noreferrer">Cloudflare's global network</a>
        for browser automation, web scraping, testing, and content generation.
      </p>
    </div>

    <div class="guides-section-label">Explore demos</div>

    <div class="card-grid">
      <router-link
        v-for="(r, idx) in resources"
        :key="idx"
        :to="r.to"
        class="resource-card"
      >
        <div class="card-thumb" :style="{ background: r.bg }">
          <span class="card-icon" v-html="r.icon"></span>
        </div>
        <div class="card-body-section">
          <div class="card-title">{{ r.title }}</div>
          <div class="card-desc">{{ r.desc }}</div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BrGuides',
  data() {
    return {
      resources: [
        {
          to: '/br-introduction',
          title: 'BR Introduction',
          desc: 'Learn what Cloudflare Browser Rendering is, pricing, and common use cases.',
          bg: 'linear-gradient(135deg, #FFF3E8 0%, #FFE0C2 100%)',
          icon: '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="3" width="18" height="14" rx="2" stroke="#F6821F" stroke-width="1.8"/><path d="M8 21h8M12 17v4" stroke="#F6821F" stroke-width="1.8" stroke-linecap="round"/></svg>'
        },
        {
          to: '/content-generation',
          title: 'BR REST API Demo',
          desc: 'Screenshot, PDF, scrape, markdown and more — try every REST API endpoint live.',
          bg: 'linear-gradient(135deg, #E8F4FF 0%, #C5DFFF 100%)',
          icon: '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 6h16M4 10h16M4 14h10" stroke="#3B82F6" stroke-width="1.8" stroke-linecap="round"/><rect x="13" y="13" width="8" height="6" rx="1" stroke="#3B82F6" stroke-width="1.8"/></svg>'
        },
        {
          to: '/make-browser-talk',
          title: 'Make Your Browser Talk',
          desc: 'Convert web page content or custom text to speech using Workers AI TTS.',
          bg: 'linear-gradient(135deg, #F0FFF4 0%, #C6F6D5 100%)',
          icon: '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" stroke="#22C55E" stroke-width="1.8"/><path d="M19 10v2a7 7 0 0 1-14 0v-2M12 19v4M8 23h8" stroke="#22C55E" stroke-width="1.8" stroke-linecap="round"/></svg>'
        },
        {
          to: '/br-withai',
          title: 'BR with AI',
          desc: 'Combine Browser Rendering with Workers AI for intelligent web automation.',
          bg: 'linear-gradient(135deg, #FDF4FF 0%, #EDD5FF 100%)',
          icon: '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="9" stroke="#A855F7" stroke-width="1.8"/><path d="M9 12l2 2 4-4" stroke="#A855F7" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        }
      ]
    }
  }
}
</script>

<style scoped>
.brguides {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
}

.guides-hero {
  text-align: center;
  padding: 2.5rem 0 2rem;
}

.guides-title {
  font-size: 2.4rem;
  font-weight: 700;
  color: #F6821F;
  letter-spacing: -0.03em;
  margin: 0 0 0.75rem;
  line-height: 1.15;
}

.guides-subtitle {
  font-size: 15px;
  color: #6B7280;
  max-width: 540px;
  margin: 0 auto;
  line-height: 1.6;
}
.guides-subtitle a {
  color: #F6821F;
  text-decoration: none;
  font-weight: 500;
}
.guides-subtitle a:hover { text-decoration: underline; }

.guides-section-label {
  font-size: 13px;
  font-weight: 600;
  color: #6B7280;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-bottom: 0.75rem;
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}

.resource-card {
  background: #FFFFFF;
  border: 1px solid #E4E4E0;
  border-radius: 12px;
  overflow: hidden;
  text-decoration: none;
  display: flex;
  flex-direction: column;
  transition: box-shadow 0.18s ease, transform 0.18s ease, border-color 0.18s ease;
  cursor: pointer;
}
.resource-card:hover {
  box-shadow: 0 8px 28px rgba(0,0,0,0.09);
  transform: translateY(-2px);
  border-color: #D1D1CE;
}

.card-thumb {
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.9;
}

.card-body-section {
  padding: 1rem 1.1rem 1.1rem;
}

.card-title {
  font-size: 15px;
  font-weight: 600;
  color: #1D1D1D;
  margin-bottom: 0.3rem;
}

.card-desc {
  font-size: 13px;
  color: #6B7280;
  line-height: 1.5;
}

@media (max-width: 580px) {
  .card-grid { grid-template-columns: 1fr; }
  .guides-title { font-size: 1.9rem; }
}
</style>